import React from "react";

function StickyTableWrapper({
  children,
  maxHeight = "500px",
  rowHeight = 40,
  headerRowCount = 1,
  className = "",
  handleScroll,
  enableScroll,
}) {
  const instanceId = React.useMemo(
    () => `sticky-table-${Math.random().toString(36).slice(2, 9)}`,
    []
  );

  const stickyStyles = React.useMemo(() => {
    return Array.from({ length: headerRowCount })
      .map(
        (_, i) => `
          .${instanceId} thead tr:nth-child(${i + 1}) th {
            top: ${i * rowHeight}px;
            position: sticky;
            z-index: 10;
            height: ${rowHeight}px;
            box-shadow: inset 0 0 0 0.5px #e2e8f0;
          }
        `
      )
      .join("");
  }, [instanceId, headerRowCount, rowHeight]);

  function onScroll(e) {
    const container = e.currentTarget;

    if (!container || !enableScroll || !handleScroll) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    if (scrollTop + clientHeight >= scrollHeight - 100) {
      handleScroll();
    }
  }

  return (
    <div
      className={`${instanceId} ${className} overflow-y-auto`}
      style={{ maxHeight }}
      onScroll={enableScroll && handleScroll ? onScroll : undefined}
    >
      <style>{stickyStyles}</style>
      {children}
    </div>
  );
}

export default StickyTableWrapper;
